import { Component, Injectable, Input, Output, EventEmitter } from '@angular/core'


@Injectable()
export class DropzoneService {
    @Output() uploadFiles: EventEmitter<any> = new EventEmitter();
    @Output() invoiceUploaded: EventEmitter<any> = new EventEmitter();
    @Output() invoiceUploadedCount: EventEmitter<any> = new EventEmitter();
    @Output() sendFileName:EventEmitter<any>= new EventEmitter();
    @Output() sendEdiFileName:EventEmitter<any>= new EventEmitter();
    @Output() responseData:EventEmitter<any>= new EventEmitter();
    @Output() deletedItem:EventEmitter<any>=new EventEmitter();
    @Output() uploadPdf: EventEmitter<any> = new EventEmitter();
    @Output() pdfUploaded: EventEmitter<any> = new EventEmitter();
    @Output() pdfUploadedCount: EventEmitter<any> = new EventEmitter();
    @Output() sendpdfFileName:EventEmitter<any>= new EventEmitter();
    @Output() responsePdfData:EventEmitter<any>= new EventEmitter();
    @Output() responseerrorPdfData:EventEmitter<any>= new EventEmitter();

    @Output() bulkImportFiles:EventEmitter<any>= new EventEmitter();
    @Output() bulkInvitationUploaded: EventEmitter<any> = new EventEmitter();
    @Output() responsebulkinvitationData:EventEmitter<any>= new EventEmitter();
    @Output() bulkinviteRemovedData: EventEmitter<any> = new EventEmitter();
    @Output() sendbulkImportFileName:EventEmitter<any>= new EventEmitter();

    
    // @Output() bulkFileResponse:EventEmitter<any>=new EventEmitter();
    // @Output() bulkUploadComplete:EventEmitter<any>=new EventEmitter();


    @Output() csvUploadedCount: EventEmitter<any> = new EventEmitter();
    @Output() csvUploaded: EventEmitter<any> = new EventEmitter();
    @Output() csvresponseData:EventEmitter<any>= new EventEmitter();
    // @Output() sendcsvFileName:EventEmitter<any>= new EventEmitter();
    constructor() {}
    manipulateFiles(data){
        this.uploadFiles.emit(data);
    }
    deletedFile(fileId){
        this.deletedItem.emit(fileId);
      }
    invoiceCreated(status){
        this.invoiceUploaded.emit(status);
    }
    invoiceUploadCount(count){
      this.invoiceUploadedCount.emit(count);
    }
    sendFilesName(name){
        this.sendFileName.emit(name);
    }
    sendEdiFilesName(name){
        this.sendEdiFileName.emit(name);
    }
    reponse(name){
        this.responseData.emit(name);
    }
    manipulatePdfFiles(data){
        this.uploadPdf.emit(data);
    }
    pdfCreated(status){
        this.pdfUploaded.emit(status);
    }
    pdfUploadCount(count){
        this.pdfUploadedCount.emit(count);
      }
    sendpdfFilesName(name){
       this.sendpdfFileName.emit(name);
    }
    pdfreponse(name){
        this.responsePdfData.emit(name);
    }
    pdferrorreponse(name){
        this.responseerrorPdfData.emit(name);
    }


    sendbulkImportsFileName(name){
        this.sendbulkImportFileName.emit(name);
    }
    bulkImportFilesName(fileName){
        this.bulkImportFiles.emit(fileName);
    }
    bulkinvitationCreated(status){
        this.bulkInvitationUploaded.emit(status);
    }
    bulkinvitereponse(name){
        this.responsebulkinvitationData.emit(name);
    }
    bulkinviteRemove(name){
        this.bulkinviteRemovedData.emit(name);
    }
 
   
}
